import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './TipePengurangPajak.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

const TipePengurangPajakTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
  }

  return (
    <>
    <TableWrapper
      baseId="mod-table-sample"
      title={t.translate('modules.tipePengurangPajak.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Kode',
          searchable: true,
          key: 'kode',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kode)
        },{
          label: 'Nama',
          searchable: true,
          key: 'nama',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nama)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        },{
          label: 'Nilai Minimal',
          searchable: true,
          key: 'nilaiMinimal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nilaiMinimal)
        },{
          label: 'Nilai Maksimal',
          searchable: true,
          key: 'nilaiMaksimal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nilaiMaksimal)
        },{
          label: 'Nilai Pengurang Flat',
          searchable: true,
          key: 'nilaiPengurangFlat',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nilaiPengurangFlat)
        },{
          label: 'Referensi',
          searchable: true,
          key: 'referensi',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.referensi)
        },{
          label: 'Tarif Pengurang Persen',
          searchable: true,
          key: 'tarifPengurangPersen',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarifPengurangPersen)
        },{
          label: 'Tipe Tarif',
          searchable: true,
          key: 'tipeTarif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tipeTarif)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/tipe-pengurang-pajak/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/tipe-pengurang-pajak/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default TipePengurangPajakTable
